(ns app.front.view.group.reporting.property-attributes
  (:require [app.domain.property.model :as property-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.config-pills :as ui-config-pills]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::property-attribute-templates
  :<- [::gas/group]
  :<- [::entities/context]
  (fn [[group ctx] _]
    (->> (entities/find-entities ctx {:entity/type  :entity.type/property-attribute-template
                                      :domain/state :property-attribute-template.state/enabled})
         (filter (fn [attr]
                   (contains? (set (:property-attribute-template/visible-in-groups attr)) group)))
         (sort-by :ordered/order))))

(rf/reg-sub ::selected-attributes
  :-> ::selected-attributes)

(rf/reg-event-db ::set-selected-attributes
  (fn [db [_ attributes]]
    (assoc db ::selected-attributes attributes)))

(rf/reg-event-db ::add-attribute
  (fn [db [_ attr-id]]
    (update db ::selected-attributes (comp vec conj) attr-id)))

(rf/reg-event-db ::remove-attribute
  (fn [db [_ attr-id]]
    (update db ::selected-attributes (partial filterv #(not= % attr-id)))))

(rf/reg-event-db ::select-attribute-to-add
  (fn [db [_ attr-id]]
    (assoc db ::candidate-for-select attr-id)))

(rf/reg-sub ::candidate-for-select
  :-> ::candidate-for-select)

(rf/reg-sub ::show-confidentiality-warning?
  :<- [::candidate-for-select]
  :<- [::entities/context]
  (fn [[attr-id ctx] _]
    (boolean (some->> attr-id
                      (entities/find-entity ctx)
                      :property-attribute-template/visibility
                      (= :property-attribute-template.visibility/write-authority)))))

(defn property-attribute-selector [tr]
  (let [lang      (<sub [:language])
        templates (<sub [::property-attribute-templates])
        selected  (<sub [::selected-attributes])]
    [:div.flex.flex-col.mt-2.mb-2
     [:h3.m-0 (tr [:reporting/property-attributes])]
     [:div.mt-2
      [ui-config-pills/config-pills
       (util/mmap {:id                "property-attribute-selector"
                   :val->str          (fn [id]
                                        (-> (p/find-first templates {:db/id id})
                                            (property-model/attribute-template-name lang)))
                   :add-button-text   (tr [:reporting/add-property-attribute])
                   :selected          selected
                   :legend-text       (tr [:reporting/selected-property-attributes])
                   :empty-placeholder (tr [:reporting/no-property-attributes])
                   :add-item          #(>evt [::add-attribute %])
                   :remove-item       #(>evt [::remove-attribute %])
                   :values            (map :db/id templates)
                   :on-select         #(>evt [::select-attribute-to-add %])}
                  tr)]]
     (when (<sub [::show-confidentiality-warning?])
       [ui/warning {:class "max-w-xl"} "Confidential information"])]))
